import { render, staticRenderFns } from "./ProblemSolvingView.vue?vue&type=template&id=5e22d92f"
import script from "./ProblemSolvingView.vue?vue&type=script&lang=js"
export * from "./ProblemSolvingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports